module.exports = __webpack_public_path__ + "img/Zwingelberg2022.14558ee9.jpg";